const PENDING = 'pending'
const ACCEPTED = 'accepted'
const DECLINED = 'declined'
const CANCELLED = 'cancelled'

const SHARED_TO_EDIT_INVITED = 'shareToEdit:invited'
const SHARED_TO_EDIT_REMOVED = 'shareToEdit:removed'
const SHARED_TO_EDIT_CLAIMED = 'shareToEdit:claimed'

export default {
  PENDING,
  ACCEPTED,
  DECLINED,
  CANCELLED,
  SHARED_TO_EDIT_INVITED,
  SHARED_TO_EDIT_REMOVED,
  SHARED_TO_EDIT_CLAIMED,
}
